export default {
  PRODUCT: "product"
};
